import { message } from "antd";
import * as XLSX from "xlsx";

export async function exportLoansExcel({
  getDirectusClient,
  readItems,
  userRoleID,
  userBodega,
  permisos,
  validarpermiso,
  fileName = undefined,
  tipo,
}) {
  if (!validarpermiso("prestamos", "read", permisos)) {
    message.error("No tiene permisos para descargar préstamos");
    return;
  }

  try {
    const directus = await getDirectusClient();
    
    // Primero obtener todos los préstamos
    const prestamos = await directus.request(
      readItems("prestamos", {
        fields: [
          "id",
          "date_created",
          "tipo",
          "estado",
          "vendedor.first_name",
          "vendedor.last_name",
        ],
        filter: {
          vendedor: {
            role: { name: { _eq: tipo } },
          },
          ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
            ? {
                vendedor: {
                  bodega: {
                    id: { _eq: userBodega },
                  },
                },
              }
            : {}),
        },
        sort: ["-date_created"],
        limit: -1,
      })
    );

    const excelData = [];

    // Crear un array de promesas para procesar todos los préstamos en paralelo
    const prestamoPromises = prestamos.map(async (prestamo) => {
      const vendedor = `${prestamo.vendedor?.first_name || ""} ${
        prestamo.vendedor?.last_name || ""
      }`.trim();
      const fecha = new Date(prestamo.date_created).toLocaleDateString("es-ES");

      // Obtener seriales y productos no serializados en paralelo
      const [seriales, productosNoSerializados] = await Promise.all([
        directus.request(
          readItems("seriales", {
            fields: [
              "id",
              "serial",
              "estado",
              "producto.nombre",
              "producto.preciosinimp",
              "producto.grupo.impuesto",
            ],
            filter: {
              prestamo: {
                prestamos_id: { _eq: prestamo.id },
              },
            },
            limit: -1,
          })
        ),
        directus.request(
          readItems("inventario_ns_prestamo", {
            fields: [
              "id",
              "cantidad",
              "inventario_ns.nombre",
              "inventario_ns.producto.preciosinimp",
              "inventario_ns.producto.grupo.impuesto",
            ],
            filter: {
              prestamos: {
                prestamos_id: { _eq: prestamo.id },
              },
            },
            limit: -1,
          })
        ),
      ]);

      const prestamoData = [];

      // Procesar seriales
      if (seriales && seriales.length > 0) {
        seriales.forEach((serial) => {
          if (serial.producto) {
            const precio = parseFloat(serial.producto.preciosinimp || 0);
            const impuesto = parseFloat(serial.producto.grupo?.impuesto || 0);
            const total = precio * (1 + impuesto / 100);
            prestamoData.push({
              Serial: serial.serial || "",
              Producto: serial.producto.nombre || "",
              Precio: precio,
              "Impuesto (%)": impuesto,
              Total: total,
              Vendedor: vendedor,
              Tipo: prestamo.tipo || "",
              Fecha: fecha,
              Estado: prestamo.estado || "",
            });
          }
        });
      }

      // Procesar productos no serializados
      if (productosNoSerializados && productosNoSerializados.length > 0) {
        productosNoSerializados.forEach((item) => {
          const inventario = item.inventario_ns;
          if (inventario) {
            const cantidad = parseFloat(item.cantidad || 0);
            const precio = parseFloat(inventario.producto?.preciosinimp || 0);
            const impuesto = parseFloat(inventario.producto?.grupo?.impuesto || 0);
            const total = cantidad * precio * (1 + impuesto / 100);
            prestamoData.push({
              Serial: `No Serializado (${cantidad} unidades)`,
              Producto: inventario.nombre || "",
              Precio: precio,
              "Impuesto (%)": impuesto,
              Total: total,
              Vendedor: vendedor,
              Tipo: prestamo.tipo || "",
              Fecha: fecha,
              Estado: prestamo.estado || "",
            });
          }
        });
      }

      return prestamoData;
    });

    // Esperar todas las promesas y combinar los resultados
    const resultados = await Promise.all(prestamoPromises);
    resultados.forEach((prestamoData) => {
      excelData.push(...prestamoData);
    });

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const columnWidths = [
      { wch: 20 },
      { wch: 30 },
      { wch: 12 },
      { wch: 12 },
      { wch: 12 },
      { wch: 25 },
      { wch: 15 },
      { wch: 12 },
      { wch: 15 },
    ];
    worksheet["!cols"] = columnWidths;
    XLSX.utils.book_append_sheet(workbook, worksheet, "Préstamos");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download =
      fileName || `prestamos_${new Date().toISOString().split("T")[0]}.xlsx`;
    link.click();
    URL.revokeObjectURL(link.href);
    message.success(
      `Se descargaron ${excelData.length} registros exitosamente`
    );
  } catch (error) {
    console.error("Error al descargar préstamos:", error);
    message.error("Error al descargar préstamos");
  }
}
